import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  zaiToast: {
    key: 'Zai-toast',
    defaultValue: 'está pronto para você!',
  },
})
